// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"0001b075","910":"cf59057d","956":"7f2b848b"}[chunkId] + ".chunk.js";
};